export default class FirebaseError extends Error {
    constructor(message) {
      super("Firebase Error: " + message); // (1)
      this.name = "FirebaseError"; // (2)
    }
  }
